import React, { Component } from "react";
import axios from "axios";

export class Step3Technology extends Component {
  constructor(props) {
    super(props);

    this.state = {
      technology: props.formData.technology || [],
      technologies: [],
      loading: true,
      error: "",
    };
  }

  componentDidMount() {
    this.getTechnology();
  }

  getTechnology = () => {
    const formData = new FormData();

    // domain_id selected in Step2
    formData.append(
      "domain_id",
      this.props.formData.internshipDomain
    );

    axios
      .post(
        "https://idealtechnoride.in/api/technology",
        formData
      )
      .then((res) => {
        this.setState({
          technologies: res.data,
          loading: false,
        });
      })
      .catch((err) => {
        console.log(err);

        this.setState({
          loading: false,
          error: "Unable to load technologies.",
        });
      });
  };

  handleChange = (e) => {
    const { value, checked } = e.target;

    let technology = [...this.state.technology];

    if (checked) {
      technology.push(value);
    } else {
      technology = technology.filter((item) => item !== value);
    }

    this.setState({
      technology,
      error: "",
    });
  };

  handleNext = () => {
    if (this.state.technology.length === 0) {
      this.setState({
        error: "Please select at least one technology.",
      });
      return;
    }

    this.props.updateFormData({
      technology: this.state.technology,
    });

    this.props.nextStep();
  };

  render() {
    const { technologies, loading } = this.state;

    return (
      <div className="container py-4">
        <div className="card shadow border-0">
          <div className="card-header bg-success text-white">
            <h3 className="mb-0">
              Step 3 : Select Technology
            </h3>
          </div>

          <div className="card-body">

            <div className="alert alert-info">
              <strong>Selected Domain :</strong>{" "}
              {this.props.formData.internshipDomainName}
            </div>

            {loading ? (
              <div className="text-center py-5">
                Loading Technologies...
              </div>
            ) : (
              <div className="row">

                {technologies.map((tech) => (

                  <div
                    className="col-md-6 mb-3"
                    key={tech.technology_id}
                  >

                    <div className="card h-100 border">

                      <div className="card-body">

                        <div className="form-check">

                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`tech${tech.technology_id}`}
                            value={tech.technology_name}
                            checked={this.state.technology.includes(
                              tech.technology_name
                            )}
                            onChange={this.handleChange}
                          />

                          <label
                            htmlFor={`tech${tech.technology_id}`}
                            className="form-check-label fw-bold"
                          >
                            {tech.technology_name}
                          </label>

                        </div>

                        {tech.technology_description && (
                          <small className="text-muted d-block mt-2">
                            {tech.technology_description}
                          </small>
                        )}

                      </div>

                    </div>

                  </div>

                ))}

              </div>
            )}

            {this.state.error && (
              <div className="alert alert-danger mt-3">
                {this.state.error}
              </div>
            )}

            <hr />

            <div className="d-flex justify-content-between">

              <button
                className="btn btn-outline-secondary"
                onClick={this.props.prevStep}
              >
                Previous
              </button>

              <button
                className="btn btn-success"
                onClick={this.handleNext}
              >
                Next
              </button>

            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default Step3Technology;